import React from "react";

import { useTranslation } from "utils";

import { Button, Flex, Icon, Typography } from "components";

const GREY_600 = "#6D6D6D";

export const NoMatchesFeedback = ({ handleClearFilters }: { handleClearFilters: () => void }) => {
  const { t } = useTranslation("allFieldView");

  return (
    <Flex className="padding-200" vertical align="center" justify="center" gap="1rem">
      <Icon iconName="tabler/search-no-results" size="xxxl" color={GREY_600} />
      <Flex vertical align="center" justify="center" gap="0.5rem">
        <Typography variant="paragraph-m" style={{ textAlign: "center" }} className="margin-0">
          {t("fieldFilterOptions.noMatchesFound")}
        </Typography>
        <Button type="text" onClick={handleClearFilters}>
          {t("fieldFilterOptions.clearFilters")}
        </Button>
      </Flex>
    </Flex>
  );
};
